import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('articoli');
export const actions = helper.createActions('articoli', actionTypes);
